module.exports = __webpack_public_path__ + "static/media/bscscan-logo.2240a5a5.svg";